import Vue from 'vue'
import VueRouter from 'vue-router'

// eslint-disable-next-line import/extensions
//  Dashboard

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/dashboard',
      name: 'home',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/dashboard/',
      },
    },
    {
      path: '/',
      name: 'welcome',
      component: () => import('@/views/Welcome.vue'),
    },
    {
      path: '/warehouse',
      name: 'warehouse-select',
      component: () => import('@/views/warehouseDashboard/selectwarehouse.vue'),
      meta: {
        pageTitle: 'Warehouse Select',
        breadcrumb: [
          {
            text: 'warehouse Select',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/warehouse-dashboard/',
      },
    },
    {
      path: '/warehouse/:id/:name',
      name: 'warehouse-dashboard',
      component: () => import('@/views/warehouseDashboard/WarehouseDashboard.vue'),
      meta: {
        pageTitle: 'Warehouse Dashboard',
        breadcrumb: [
          {
            text: 'Warehouse Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/all-orders',
      name: 'all-orders',
      component: () => import('@/views/AllOrders.vue'),
      meta: {
        pageTitle: 'All Orders',
        breadcrumb: [
          {
            text: 'All Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/all-orders/',
      },
    },
    {
      path: '/operations/orders/create',
      name: 'order-create',
      component: () => import('@/views/order/create/OrderCreateHome.vue'),
      meta: {
        pageTitle: 'Order Create',
        breadcrumb: [
          {
            text: 'Create',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/order-create/',
      },
    },
    {
      path: '/operations/first-mile-operation',
      name: 'first-mile-operation',
      component: () => import('@/views/order/FirstMileOperation.vue'),
      meta: {
        pageTitle: 'First Mile Operation',
        breadcrumb: [
          {
            text: 'First Mile Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/operations/first-mile-operation/:name',
      name: 'Selected-first-mile-operation',
      component: () => import('@/views/order/SelectedFirstMileOperation.vue'),
      meta: {
        pageTitle: 'First Mile Operation',
        breadcrumb: [
          {
            text: 'First Mile Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/operations/middle-mile-operation',
      name: 'middle-mile-operation',
      component: () => import('@/views/order/MiddleMileOperation.vue'),
      meta: {
        pageTitle: 'Middle Mile Operation',
        breadcrumb: [
          {
            text: 'Middle Mile Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#2-toc-title',
      },
    },
    {
      path: '/operations/middle-mile-operation/:name',
      name: 'Selected-middle-mile-operation',
      component: () => import('@/views/order/SelectedMiddleMileOperation.vue'),
      meta: {
        pageTitle: 'Middle Mile Operation',
        breadcrumb: [
          {
            text: 'Middle Mile Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#2-toc-title',
      },
    },
    {
      path: '/operations/last-mile-operation',
      name: 'last-mile-operation',
      component: () => import('@/views/order/LastMileOperation.vue'),
      meta: {
        pageTitle: 'Last Mile Operation',
        breadcrumb: [
          {
            text: 'Last Mile Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#2-toc-title',
      },
    },
    {
      path: '/operations/last-mile-operation/:name',
      name: 'Selected-last-mile-operation',
      component: () => import('@/views/order/SelectedLastMileOperation.vue'),
      meta: {
        pageTitle: 'Last Mile Operation',
        breadcrumb: [
          {
            text: 'Last Mile Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#2-toc-title',
      },
    },
    {
      path: '/operations/sorting-devices',
      name: 'sorting-devices',
      component: () => import('@/views/sorting/SortingDevices.vue'),
      meta: {
        pageTitle: 'Dispatch Sorting Devices',
        breadcrumb: [
          {
            text: 'Dispatch Sorting Devices',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/operations/sorting-operation',
      name: 'sorting-operation',
      component: () => import('@/views/order/SortingOperation.vue'),
      meta: {
        pageTitle: 'Dispatch Sorting Operation',
        breadcrumb: [
          {
            text: 'Dispatch Sorting Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/operations/sorting-report',
      name: 'sorting-report',
      component: () => import('@/views/reports/SortingReport.vue'),
      meta: {
        pageTitle: 'Dispatch Sorting Reporting',
        breadcrumb: [
          {
            text: 'Dispatch Sorting Reporting',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/operations/return-sorting-operation',
      name: 'return-sorting-operation',
      // eslint-disable-next-line import/no-unresolved
      component: () => import('@/views/order/ReturnSortingOperation.vue'),
      meta: {
        pageTitle: 'Return Sorting Operation',
        breadcrumb: [
          {
            text: 'Return Sorting Operation',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/sorting/return-bag-orders/:id',
      name: 'return-bag-orders',
      // eslint-disable-next-line import/no-unresolved
      component: () => import('@/views/reports/ReturnBagOrdersList.vue'),
      meta: {
        pageTitle: 'Return Bag Reporting',
        breadcrumb: [
          {
            text: 'Return Bag Reporting',
            to: { name: 'return-bag-reporting' },
          },
          {
            text: 'Bag Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sorting/return-bag-reporting',
      name: 'return-bag-reporting',
      // eslint-disable-next-line import/no-unresolved
      component: () => import('@/views/reports/ReturnBagReporting.vue'),
      meta: {
        pageTitle: 'Return Bag Reporting',
        breadcrumb: [
          {
            text: 'Return Bag Reporting',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sorting/sorting-session-report',
      name: 'sorting-session-report',
      component: () => import('@/views/reports/SortingSessionReport.vue'),
      meta: {
        pageTitle: 'Sorting Reporting',
        breadcrumb: [
          {
            text: 'Sorting Reporting',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/sorting/sorting-dispatch-report',
      name: 'sorting-dispatch-report',
      component: () => import('@/views/reports/DispatchReport.vue'),
      meta: {
        pageTitle: 'Dispatch Reporting',
        breadcrumb: [
          {
            text: 'Dispatch Reporting',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/operations/sorting-bucket-management',
      name: 'sorting-bucket-management',
      component: () => import('@/views/sorting/SortingBucketManagement.vue'),
      meta: {
        pageTitle: 'Bucket Management',
        breadcrumb: [
          {
            text: 'Bucket Management',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/sorting/sorting-activity-log',
      name: 'sorting-activity-log',
      component: () => import('@/views/sorting/SortingActivityLog.vue'),
      meta: {
        pageTitle: 'Sorting Activity Log',
        breadcrumb: [
          {
            text: 'Sorting Activity Log',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#0-toc-title',
      },
    },
    {
      path: '/print-pod',
      name: 'print-pod',
      component: () => import('@/components/print/Dispatch.vue'),
      meta: {
        pageTitle: 'Print POD',
        breadcrumb: [
          {
            text: 'Print POD',
            active: true,
          },
        ],
        contentRenderer: 'pdf',
      },
    },
    {
      path: '/print-bag',
      name: 'print-bag',
      component: () => import('@/components/print/PrintBag.vue'),
      meta: {
        pageTitle: 'Print Bag',
        breadcrumb: [
          {
            text: 'Print Bag',
            active: true,
          },
        ],
        contentRenderer: 'pdf',
      },
    },
    {
      path: '/waybill-customizer/:id',
      name: 'waybill-customizer',
      component: () => import('@/views/waybill-customizer/WaybillCustomizer.vue'),
      meta: {
        pageTitle: 'Customizer',
        breadcrumb: [
          {
            text: 'Waybill Customizer',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/rider-overview',
      name: 'rider-overview',
      component: () => import('@/components/FinanceModuleForms/FinanceOverview/RiderOverview.vue'),
      meta: {
        pageTitle: 'Rider',
        breadcrumb: [
          {
            text: 'Rider Overview',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/overview/#1-toc-title',
      },
    },
    {
      path: '/operations/rider-finance',
      name: 'rider-finance',
      component: () => import('@/views/finance/FinanceModule.vue'),
      meta: {
        pageTitle: 'Rider Deposits',
        breadcrumb: [
          {
            text: 'Rider Finance',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/finance-deposits/#0-toc-title',
      },
    },
    {
      path: '/operations/rider-commission',
      name: 'rider-commission',
      component: () => import('@/views/finance/RiderCommission.vue'),
      meta: {
        pageTitle: 'Rider Commission Invoices',
        breadcrumb: [
          {
            text: 'Rider Commission Finance',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/finance-deposits/#0-toc-title',
      },
    },
    {
      path: '/operations/agency-commission',
      name: 'agency-commission',
      component: () => import('@/views/finance/AgentCommission.vue'),
      meta: {
        pageTitle: 'Agent Commission Invoices',
        breadcrumb: [
          {
            text: 'Agent Commission Finance',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/finance-deposits/#0-toc-title',
      },
    },
    {
      path: '/operations/add-new-rider-deposit',
      name: 'add-new-rider-deposit',
      component: () => import('@/components/FinanceModuleForms/AddNewDeposit.vue'),
      meta: {
        pageTitle: 'Add New Deposit',
        breadcrumb: [
          {
            text: 'Rider Finance',
            to: { name: 'rider-finance' },
          },
          {
            text: 'Add New Deposit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/add-new-rider-commission',
      name: 'add-new-rider-commission',
      component: () => import('@/components/FinanceModuleForms/AddNewCommissionInvoice.vue'),
      meta: {
        pageTitle: 'Add New Commission Invoice',
        breadcrumb: [
          {
            text: 'Rider Commission Finance',
            to: { name: 'rider-commission' },
          },
          {
            text: 'Add New Commission Invoice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/add-new-agency-commission',
      name: 'add-new-agency-commission',
      component: () => import('@/components/FinanceModuleForms/AddNewAgentCommissionInvoice.vue'),
      meta: {
        pageTitle: 'Add New Commission Invoice',
        breadcrumb: [
          {
            text: 'Agent Commission Finance',
            to: { name: 'agency-commission' },
          },
          {
            text: 'Add New Commission Invoice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/rider-deposit-orders/:id',
      name: 'rider-deposit-orders',
      component: () => import('@/components/FinanceModuleForms/ActionForms/OrderList.vue'),
      meta: {
        pageTitle: 'Rider Orders',
        breadcrumb: [
          {
            text: 'Rider Finance',
            to: { name: 'rider-finance' },
          },
          {
            text: 'Rider Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/rider-commission-deposits/:id',
      name: 'rider-commission-deposits',
      component: () => import('@/components/FinanceModuleForms/ActionForms/DepositList.vue'),
      meta: {
        pageTitle: 'Rider Deposits',
        breadcrumb: [
          {
            text: 'Rider Commission Finance',
            to: { name: 'rider-commission' },
          },
          {
            text: 'Rider Deposits',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/agency-commission-deposits/:id',
      name: 'agency-commission-deposits',
      component: () => import('@/components/FinanceModuleForms/ActionAgentForms/DepositList.vue'),
      meta: {
        pageTitle: 'Agent Deposits',
        breadcrumb: [
          {
            text: 'Agent Commission Finance',
            to: { name: 'agency-commission' },
          },
          {
            text: 'Agent Deposits',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/agent-overview',
      name: 'agent-overview',
      component: () => import('@/components/FinanceModuleForms/FinanceOverview/AgentOverview.vue'),
      meta: {
        pageTitle: 'Agent',
        breadcrumb: [
          {
            text: 'Agent Overview',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/overview/#3-toc-title',
      },
    },
    {
      path: '/operations/agent-finance',
      name: 'agent-finance',
      component: () => import('@/views/finance/AgentFinance.vue'),
      meta: {
        pageTitle: 'Agent Deposits',
        breadcrumb: [
          {
            text: 'Agent Finance',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/finance-deposits/#2-toc-title',
      },
    },
    {
      path: '/operations/add-new-agent-deposit',
      name: 'add-new-agent-deposit',
      component: () => import('@/components/FinanceModuleForms/AddNewAgentDeposit.vue'),
      meta: {
        pageTitle: 'Add New Deposit',
        breadcrumb: [
          {
            text: 'Agent Finance',
            to: { name: 'agent-finance' },
          },
          {
            text: 'Add New Deposit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/agent-deposit-orders/:id',
      name: 'agent-deposit-orders',
      component: () => import('@/components/FinanceModuleForms/ActionAgentForms/OrderList.vue'),
      meta: {
        pageTitle: 'Agent Orders',
        breadcrumb: [
          {
            text: 'Agent Finance',
            to: { name: 'agent-finance' },
          },
          {
            text: 'Agent Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/branch-branch',
      name: 'branch-overview',
      component: () => import('@/components/FinanceModuleForms/FinanceOverview/BranchOverview.vue'),
      meta: {
        pageTitle: 'Branch',
        breadcrumb: [
          {
            text: 'Branch Overview',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/overview/#2-toc-title',
      },
    },
    {
      path: '/operations/branch-finance',
      name: 'branch-finance',
      component: () => import('@/views/finance/BranchFinance.vue'),
      meta: {
        pageTitle: 'Branch Deposits',
        breadcrumb: [
          {
            text: 'Branch Finance',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/finance-deposits/#1-toc-title',
      },
    },
    {
      path: '/operations/add-new-branch-deposit',
      name: 'add-new-branch-deposit',
      component: () => import('@/components/FinanceModuleForms/AddNewBranchDeposit.vue'),
      meta: {
        pageTitle: 'Add New Deposit',
        breadcrumb: [
          {
            text: 'Branch Finance',
            to: { name: 'branch-finance' },
          },
          {
            text: 'Add New Deposit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/branch-deposit-orders/:id',
      name: 'branch-deposit-orders',
      component: () => import('@/components/FinanceModuleForms/ActionBranchForms/OrderList.vue'),
      meta: {
        pageTitle: 'Branch Orders',
        breadcrumb: [
          {
            text: 'Branch Finance',
            to: { name: 'branch-finance' },
          },
          {
            text: 'Branch Orders',
            active: true,
          },
        ],
      },
    },
    // Add expences
    {
      path: '/operations/branch-deposit-orders-expenses/:id',
      name: 'branch-deposit-expenses',
      component: () => import('@/components/FinanceModuleForms/ExpencesList.vue'),
      meta: {
        pageTitle: 'Deposit Expences',
        breadcrumb: [
          {
            text: 'Branch Finance',
            to: { name: 'branch-finance' },
          },
          {
            text: 'Deposit Expences',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/merchant-overview',
      name: 'merchant-overview',
      component: () => import('@/components/FinanceModuleForms/FinanceOverview/MerchatnOvewrview.vue'),
      meta: {
        pageTitle: 'Merchant',
        breadcrumb: [
          {
            text: 'Merchant Overview',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/overview/#0-toc-title',
      },
    },
    {
      path: '/operations/merchant-finance',
      name: 'merchant-finance',
      component: () => import('@/views/finance/MerchantFinance.vue'),
      meta: {
        pageTitle: 'Invoices',
        breadcrumb: [
          {
            text: 'Merchant',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/finance-invoices/',
      },
    },
    {
      path: '/operations/walking-finance',
      name: 'walking-finance',
      component: () => import('@/views/finance/MerchantFinance.vue'),
      meta: {
        pageTitle: 'Invoices',
        breadcrumb: [
          {
            text: 'Walking Customer',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/finance-invoices/',
      },
    },
    {
      path: '/operations/add-new-merchant-invoice',
      name: 'add-new-merchant-invoice',
      component: () => import('@/components/FinanceModuleForms/AddNewInvoice.vue'),
      meta: {
        pageTitle: 'Add New Invoice',
        breadcrumb: [
          {
            text: 'Merchant Finance',
            to: { name: 'merchant-finance' },
          },
          {
            text: 'Add New Invoice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/merchant-orders/:id',
      name: 'merchant-orders',
      component: () => import('@/components/FinanceModuleForms/ActionMerchantForms/OrderList.vue'),
      meta: {
        pageTitle: 'Invoices',
        breadcrumb: [
          {
            text: 'Merchant',
            to: { name: 'merchant-finance' },
          },
          {
            text: 'Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/walking-orders/:id',
      name: 'walking-orders',
      component: () => import('@/components/FinanceModuleForms/ActionMerchantForms/OrderList.vue'),
      meta: {
        pageTitle: 'Invoices',
        breadcrumb: [
          {
            text: 'Walking Customer',
            to: { name: 'walking-finance' },
          },
          {
            text: 'Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/merchant-finance-invoice/:id',
      name: 'merchant-finance-invoice',
      component: () => import('@/components/FinanceModuleForms/ActionMerchantForms/merchantInvoicePreview.vue'),
      meta: {
        pageTitle: '',
        contentRenderer: 'pdf',
      },
    },
    {
      path: '/operations/walking-finance-invoice/:id',
      name: 'walking-finance-invoice',
      component: () => import('@/components/FinanceModuleForms/ActionMerchantForms/merchantInvoicePreview.vue'),
      meta: {
        pageTitle: '',
        contentRenderer: 'pdf',
      },
    },
    {
      path: '/operations/merchant-debit-notes',
      name: 'merchant-debit-notes',
      component: () => import('@/views/finance/DebitNotes.vue'),
      meta: {
        pageTitle: 'Debit Notes',
        breadcrumb: [
          {
            text: 'Debit Notes',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/add-new-merchant-debit-note',
      name: 'add-new-merchant-debit-note',
      component: () => import('@/components/FinanceModuleForms/AddNewDebitNote.vue'),
      meta: {
        pageTitle: 'Add New Debit Note',
        breadcrumb: [
          {
            text: 'Debit Notes',
            to: { name: 'merchant-debit-notes' },
          },
          {
            text: 'Add New Debit Note',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/merchant-debit-note-invoices/:id',
      name: 'merchant-debit-note-invoices',
      component: () => import('@/components/FinanceModuleForms/ActionMerchantForms/InvoiceList.vue'),
      meta: {
        pageTitle: 'Debit Notes',
        breadcrumb: [
          {
            text: 'Debit Notes',
            to: { name: 'merchant-debit-notes' },
          },
          {
            text: 'Invoices',
            active: true,
          },
        ],
      },
    },
    {
      path: '/operations/merchant-debit-note-preview/:id',
      name: 'merchant-debit-note-preview',
      component: () => import('@/components/FinanceModuleForms/ActionMerchantForms/DebitNotePreview.vue'),
      meta: {
        pageTitle: '',
        contentRenderer: 'pdf',
      },
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('@/views/reports/Reports.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#0-toc-title',
      },
    },
    {
      path: '/reports/monthly-sales/',
      name: 'monthly-sales',
      component: () => import('@/views/reports/MonthlySales.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Merchants & Sales',
            to: {
              name: 'reports',
              query: { category: 'merchants-sales' },
            },
          },
          {
            text: 'Sales Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#0-toc-title',
      },
    },
    {
      path: '/reports/branch-status-count/',
      name: 'branch-status-count',
      component: () => import('@/views/reports/BranchStatusCount.vue'),
      meta: {
        pageTitle: 'Branch Status Count',
        breadcrumb: [
          {
            text: 'Branch Status Count',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reports/branch-status-count/',
      name: 'agent-status-count',
      component: () => import('@/views/reports/AgentstatusCount.vue'),
      meta: {
        pageTitle: 'Agent Status Count',
        breadcrumb: [
          {
            text: 'Agent Status Count',
            active: true,
          },
        ],
      },
    },
    {
      path: '/administration/reasons',
      name: 'reason',
      component: () => import('@/views/reason/reason.vue'),
      meta: {
        pageTitle: 'Reasons',
        breadcrumb: [
          {
            text: 'Reasons',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reasons/',
      },
    },
    {
      path: '/reports/warehouse-status-count/',
      name: 'warehouse-status-count',
      component: () => import('@/views/reports/WarehouseStatusCount.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Merchants & Sales',
            to: {
              name: 'reports',
              query: { category: 'merchants-sales' },
            },
          },
          {
            text: 'Warehouse Status Count Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/warehouse-reports/',
      name: 'warehouse-reports',
      component: () => import('@/views/reports/WarehouseReports.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Operations & Warehouse',
            to: {
              name: 'reports',
              query: { category: 'operations-warehouse' },
            },
          },
          {
            text: 'Warehouse General Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/merchant-status-count/',
      name: 'merchant-status-count',
      component: () => import('@/views/reports/merchantStatusCount.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Merchants & Sales',
            to: {
              name: 'reports',
              query: { category: 'merchants-sales' },
            },
          },
          {
            text: 'Merchant Status Count Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/assigned-orders-reports/',
      name: 'assigned-orders-reports',
      component: () => import('@/views/reports/AssignedOrdersReports.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Operations & Warehouse',
            to: {
              name: 'reports',
              query: { category: 'operations-warehouse' },
            },
          },
          {
            text: 'Assigned Orders Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/report/returned-orders-to-merchant-report/',
      name: 'returned-orders-to-merchant-report',
      component: () => import('@/views/reports/ReturnOrderMerchant/ReturnOrderMerchant.vue'),
      meta: {
        pageTitle: 'Returned Orders to Merchant',
        breadcrumb: [
          {
            text: 'Assigned Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/report/assigned-orders-to-warehouse-report/',
      name: 'assigned-orders-to-warehouse-report',
      component: () => import('@/views/reports/AssignOrderWarehouse/AssignOrderWarehouse.vue'),
      meta: {
        pageTitle: 'Assigned Orders to Destination Warehouse',
        breadcrumb: [
          {
            text: 'Assigned Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/report/returned-orders-to-origin-warehouse-report/',
      name: 'returned-orders-to-origin-warehouse-report',
      component: () => import('@/views/reports/ReturnOrderOriginWarehouse/ReturnOrderOriginWarehouse.vue'),
      meta: {
        pageTitle: 'Returned Orders to Origin Warehouse',
        breadcrumb: [
          {
            text: 'Assigned Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/assign-orders-pickup-rider/',
      name: 'assign-orders-pickup-rider',
      component: () => import('@/views/reports/AssignOrdersPickupRider/AssignOrdersPickupRider.vue'),
      meta: {
        pageTitle: 'Assigned Orders to Pickup Rider',
        breadcrumb: [
          {
            text: 'Assigned Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/branch-expenses-report/',
      name: 'branch-expenses-report',
      component: () => import('@/views/reports/BranchExpenses/BranchExpenses.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Finance & Billing',
            to: {
              name: 'reports',
              query: { category: 'finance-billing' },
            },
          },
          {
            text: 'Branch Expenses Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/branch-progress-report/',
      name: 'branch-progress-report',
      component: () => import('@/views/reports/BranchProgress/BranchProgress.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Finance & Billing',
            to: {
              name: 'reports',
              query: { category: 'finance-billing' },
            },
          },
          {
            text: 'Branch Progress Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/to-be-invoiced-report/',
      name: 'to-be-invoiced-report',
      component: () => import('@/views/reports/ToBeInvoiced/ToBeInvoiced.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Finance & Billing',
            to: {
              name: 'reports',
              query: { category: 'finance-billing' },
            },
          },
          {
            text: 'To Be Invoiced Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/return-free-merchants-report/',
      name: 'return-free-merchants-report',
      component: () => import('@/views/reports/ReturnFreeMerchants/ReturnFreeMerchants.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Finance & Billing',
            to: {
              name: 'reports',
              query: { category: 'finance-billing' },
            },
          },
          {
            text: 'Return Free Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
        tooltip: 'This report lists merchants whose assigned rate card has a return charge of zero. For each merchant it shows how many orders were returned to the merchant and the lost delivery income on those returns — helping finance and operations track return volume and forgone income for return-free merchants.',
      },
    },
    {
      path: '/reports/merchant-inactivation-report/',
      name: 'merchant-inactivation-report',
      component: () => import('@/views/reports/MerchantInactivation/MerchantInactivation.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Staff Productivity',
            to: {
              name: 'reports',
              query: { category: 'staff-productivity' },
            },
          },
          {
            text: 'Merchant Inactivation Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/operations-reports/',
      name: 'operations-reports',
      component: () => import('@/views/reports/OperationsReports.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Operations & Warehouse',
            to: {
              name: 'reports',
              query: { category: 'operations-warehouse' },
            },
          },
          {
            text: 'Operations Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/#1-toc-title',
      },
    },
    {
      path: '/reports/branch-delivery-progress',
      name: 'branch-delivery-progress',
      component: () => import('@/views/reports/BranchDeliveryProgress/SelectBranch.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Operations & Warehouse',
            to: {
              name: 'reports',
              query: { category: 'operations-warehouse' },
            },
          },
          {
            text: 'Delivery Progress Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/warehouse-dashboard/',
      },
    },
    {
      path: '/reports/branch-delivery-progress-report/:id/:name',
      name: 'branch-delivery-progress-report',
      component: () => import('@/views/reports/BranchDeliveryProgress/BranchDeliveryProgressReport.vue'),
      meta: {
        pageTitle: 'Branch Delivery Progress',
        breadcrumb: [
          {
            text: 'Branch Delivery Progress',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reports/assign-order-summery-report',
      name: 'assign-order-summery-report',
      component: () => import('@/views/reports/AssignOrderSummery/AssignOrderSummeryReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Operations & Warehouse',
            to: {
              name: 'reports',
              query: { category: 'operations-warehouse' },
            },
          },
          {
            text: 'Assigned Order Summary Report',
            active: true,
          },
        ],
      },
    },
    {
      path: '/chat/:chatroomId',
      name: 'chat-r2',
      component: () => import('@/views/chat/Chat.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'chat-application',
      },
    },
    {
      path: '/chat',
      name: 'chat',
      component: () => import('@/views/chat/Chat.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'chat-application',
        help: 'https://curfox.com/docs/chat/',
      },
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/views/Notifications.vue'),
      meta: {
        pageTitle: 'Notification',
        breadcrumb: [
          {
            text: 'Notification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pickup-notifications',
      name: 'pickupNotifications',
      component: () => import('@/views/PickupNotifications.vue'),
      meta: {
        pageTitle: 'Notifications',
        breadcrumb: [
          {
            text: 'Pickup Requests',
            active: true,
          },
        ],
      },
    },
    {
      path: '/merchants',
      name: 'merchants',
      component: () => import('@/views/merchant/MerchantManagement.vue'),
      meta: {
        pageTitle: 'Merchants',
        breadcrumb: [
          {
            text: 'Merchants',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/user-management-customers/#0-toc-title',
      },
    },
    {
      path: '/walking-customer',
      name: 'walking-customer',
      component: () => import('@/views/walkingCustomer/WalkingCustomer.vue'),
      meta: {
        pageTitle: 'Walking Customer',
        breadcrumb: [
          {
            text: 'Walking Customer',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/user-management-customers/#1-toc-title',
      },
    },
    {
      path: '/merchant/:id',
      name: 'merchant-details-management',
      component: () => import('@/views/merchant/MerchantBusinessManagement.vue'),
      meta: {
        pageTitle: 'Merchant Business',
        breadcrumb: [
          {
            text: 'Merchants',
            to: { name: 'merchants' },
          },
          {
            text: 'Merchant Business',
            active: true,
          },
        ],
      },
    },
    {
      path: '/merchant/:id/businesses/:businessId',
      name: 'merchant-business-details',
      component: () => import('@/views/merchant/MerchantBusinessDetailsManagement.vue'),
      meta: {
        pageTitle: 'Merchant Business Details',
        breadcrumb: [
          {
            text: 'Merchants',
            to: { name: 'merchants' },
          },
          {
            text: 'Merchant Business',
            to: { name: 'merchant-details-management' },
          },
          {
            text: 'Merchant Business Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/business-profile',
      name: 'business-profile',
      component: () => import('@/components/setting/BusinessProfile.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'General & Branding',
            to: {
              name: 'business-setting',
              query: { category: 'general-branding' },
            },
          },
          {
            text: 'Business Profile',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/notification-setting',
      name: 'notification-setting',
      component: () => import('@/components/setting/Notification.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'General & Branding',
            to: {
              name: 'business-setting',
              query: { category: 'general-branding' },
            },
          },
          {
            text: 'Notification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/general-settings',
      name: 'general-settings',
      component: () => import('@/components/setting/General.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'General & Branding',
            to: {
              name: 'business-setting',
              query: { category: 'general-branding' },
            },
          },
          {
            text: 'Genaral Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/terms-and-conditions',
      name: 'terms-and-conditions',
      component: () => import('@/components/setting/TermsAndCondition.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'General & Branding',
            to: {
              name: 'business-setting',
              query: { category: 'general-branding' },
            },
          },
          {
            text: 'Terms & Conditions',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/theme-settings',
      name: 'theme-settings',
      component: () => import('@/components/setting/ThemeSetting.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'General & Branding',
            to: {
              name: 'business-setting',
              query: { category: 'general-branding' },
            },
          },
          {
            text: 'Theme Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/approval-settings',
      name: 'approval-settings',
      component: () => import('@/components/setting/ApprovalSetting.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'General & Branding',
            to: {
              name: 'business-setting',
              query: { category: 'general-branding' },
            },
          },
          {
            text: 'Approval Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/mcp-reporting',
      name: 'mcp-reporting',
      component: () => import('@/views/mcp/McpReporting.vue'),
      meta: {
        pageTitle: 'Claude AI Reporting',
        breadcrumb: [
          {
            text: 'Claude AI Reporting',
            active: true,
          },
        ],
      },
    },
    {
      path: '/mcp-authorize',
      name: 'mcp-authorize',
      component: () => import('@/views/mcp/McpAuthorize.vue'),
      meta: {
        noAuth: true, // the page itself sends anonymous users to /login and resumes afterwards
        layout: 'full',
      },
    },
    {
      path: '/system-settings/ai-settings',
      name: 'ai-settings',
      component: () => import('@/components/setting/AISetting.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'General & Branding',
            to: {
              name: 'business-setting',
              query: { category: 'general-branding' },
            },
          },
          {
            text: 'AI Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/waybill-management',
      name: 'waybill-management',
      component: () => import('@/components/setting/WaybillManagement.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Order Handling & Waybill Settings',
            to: {
              name: 'business-setting',
              query: { category: 'order-handling-waybill' },
            },
          },
          {
            text: 'Waybill Management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/volumetric-weight',
      name: 'volumetric-weight',
      component: () => import('@/components/setting/VolumetricWeight.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Order Handling & Waybill Settings',
            to: {
              name: 'business-setting',
              query: { category: 'order-handling-waybill' },
            },
          },
          {
            text: 'Volumetric Weight Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/tracking-settings',
      name: 'tracking-settings',
      component: () => import('@/components/setting/TrackImage.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Order Handling & Waybill Settings',
            to: {
              name: 'business-setting',
              query: { category: 'order-handling-waybill' },
            },
          },
          {
            text: 'Tracking Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/print-layouts',
      name: 'print-layouts',
      component: () => import('@/components/setting/Print.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Order Handling & Waybill Settings',
            to: {
              name: 'business-setting',
              query: { category: 'order-handling-waybill' },
            },
          },
          {
            text: 'Print Layouts',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/orders-settings',
      name: 'orders-settings',
      component: () => import('@/components/setting/Orders.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Order Management',
            to: {
              name: 'business-setting',
              query: { category: 'order-management' },
            },
          },
          {
            text: 'Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/auto-order-cancel',
      name: 'auto-order-cancel',
      component: () => import('@/components/setting/AutoOrderCancel.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Order Management',
            to: {
              name: 'business-setting',
              query: { category: 'order-management' },
            },
          },
          {
            text: 'Auto Order Cancellation Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/statuses-settings',
      name: 'statuses-settings',
      component: () => import('@/components/setting/Statuses.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Order Management',
            to: {
              name: 'business-setting',
              query: { category: 'order-management' },
            },
          },
          {
            text: 'Statuses',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/finance-settings',
      name: 'finance-settings',
      component: () => import('@/components/setting/Finance.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Finance & Payments',
            to: {
              name: 'business-setting',
              query: { category: 'finance-payments' },
            },
          },
          {
            text: 'Finance',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/payment-methods',
      name: 'payment-methods',
      component: () => import('@/components/setting/PaymentGateway.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Finance & Payments',
            to: {
              name: 'business-setting',
              query: { category: 'finance-payments' },
            },
          },
          {
            text: 'Payment Method',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/tax-settings',
      name: 'tax-settings',
      component: () => import('@/components/setting/Tax.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Finance & Payments',
            to: {
              name: 'business-setting',
              query: { category: 'finance-payments' },
            },
          },
          {
            text: 'Tax Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/staff-settings',
      name: 'staff-settings',
      component: () => import('@/components/setting/StaffSettings.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Access & Security',
            to: {
              name: 'business-setting',
              query: { category: 'access-security' },
            },
          },
          {
            text: 'Staff Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/change-password',
      name: 'change-password',
      component: () => import('@/components/setting/ChangePassword.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Access & Security',
            to: {
              name: 'business-setting',
              query: { category: 'access-security' },
            },
          },
          {
            text: 'Security and Privacy Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/merchant-settings',
      name: 'merchant-settings',
      component: () => import('@/components/setting/Merchant.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Access & Security',
            to: {
              name: 'business-setting',
              query: { category: 'access-security' },
            },
          },
          {
            text: 'Merchant Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/merchant-registration-settings',
      name: 'merchant-registration-settings',
      component: () => import('@/components/setting/MerchantRegistrationFormBuilder.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Access & Security',
            to: {
              name: 'business-setting',
              query: { category: 'access-security' },
            },
          },
          {
            text: 'Merchant Registration Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/merchant-agreement-settings',
      name: 'merchant-agreement-settings',
      component: () => import('@/components/setting/MerchantAgreementBuilder.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            to: { name: 'business-setting' },
          },
          {
            text: 'Access & Security',
            to: {
              name: 'business-setting',
              query: { category: 'access-security' },
            },
          },
          {
            text: 'Merchant Agreement Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/system-settings/business-setting',
      name: 'business-setting',
      component: () => import('@/views/BusinessSetting.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },
    {
      path: '/system-settings/status-setting',
      name: 'status-setting',
      component: () => import('@/components/setting/OrderStatus.vue'),
      meta: {
        pageTitle: 'Status',
        breadcrumb: [
          {
            text: 'Status Settings',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },
    {
      path: '/system-settings/flag-setting',
      name: 'flag-setting',
      component: () => import('@/components/setting/OrderFlag.vue'),
      meta: {
        pageTitle: 'Flag',
        breadcrumb: [
          {
            text: 'Flag Settings',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },
    {
      path: '/operation-settings/cities',
      name: 'city',
      component: () => import('@/views/demarcation/CityManage.vue'),
      meta: {
        pageTitle: 'City',
        breadcrumb: [
          {
            text: 'City',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/operation-settings/cities/city-create',
      name: 'city-create',
      component: () => import('@/views/demarcation/ExcelUploadCity/ExcelCityCreate.vue'),
      meta: {
        pageTitle: 'City Create',
        breadcrumb: [
          {
            text: 'Create',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/order-create/',
      },
    },
    {
      path: '/operation-settings/state/state-excel',
      name: 'state-create',
      component: () => import('@/views/demarcation/ExcelUpload.vue'),
      meta: {
        pageTitle: 'State',
        breadcrumb: [
          {
            text: 'state',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/operation-settings/state',
      name: 'state',
      component: () => import('@/views/demarcation/StateManage.vue'),
      meta: {
        pageTitle: 'State',
        breadcrumb: [
          {
            text: 'state',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/rate-card/add-rate-card/:rateCardType',
      name: 'add-rate-card',
      component: () => import('@/components/rate-card/rateCardForm.vue'),
      meta: {
        pageTitle: 'Add Rate Card',
        breadcrumb: [
          {
            text: 'Rate Card',
            active: true,
          },
        ],
        help: [
          {
            title: 'Tutorial 08 - Merchant Rate Card | Creating a new rate card Per kg',
            link: 'https://www.youtube.com/embed/FYPM7qPBi1k',
          },
          {
            title: 'Tutorial 09 - Merchant Rate Card | Creating a new rate card Per Order',
            link: 'https://www.youtube.com/embed/Z2QXTRfK4iU',
          },
          {
            title: 'Tutorial 10 - Merchant Rate Card | Assigning merchants to the rate card',
            link: 'https://www.youtube.com/embed/EJl7CLIIBKM',
          },
        ],
      },
    },
    {
      path: '/rate-card/view-rate-card/:rateCardType/:id',
      name: 'view-rate-card',
      component: () => import('@/components/rate-card/rateCardForm.vue'),
      meta: {
        pageTitle: 'View Rate Card',
        breadcrumb: [
          {
            text: 'Rate Card',
            active: true,
          },
        ],
      },
    },
    {
      path: '/rate-card/clone-rate-card/:rateCardType/:id',
      name: 'clone-rate-card',
      component: () => import('@/components/rate-card/rateCardForm.vue'),
      meta: {
        pageTitle: 'Clone Rate Card',
        breadcrumb: [
          {
            text: 'Rate Card',
            active: true,
          },
        ],
      },
    },
    {
      path: '/rate-card/update-rate-card/:rateCardType/:id',
      name: 'update-rate-card',
      component: () => import('@/components/rate-card/rateCardForm.vue'),
      meta: {
        pageTitle: 'Update Rate Card',
        breadcrumb: [
          {
            text: 'Rate Card',
            active: true,
          },
        ],
      },
    },
    {
      path: '/rate-card/delete-rate-card/:rateCardType/:id',
      name: 'delete-rate-card',
      component: () => import('@/components/rate-card/rateCardForm.vue'),
      meta: {
        pageTitle: 'Delete Rate Card',
        breadcrumb: [
          {
            text: 'Rate Card',
            active: true,
          },
        ],
      },
    },
    {
      path: '/rate-card/review-rate-card/:rateCardType/:id',
      name: 'review-rate-card',
      component: () => import('@/components/rate-card/rateCardForm.vue'),
      meta: {
        pageTitle: 'Review Rate Card',
        breadcrumb: [
          {
            text: 'Rate Card',
            active: true,
          },
        ],
      },
    },
    {
      path: '/rate-card/merchant',
      name: 'merchant-rate-card',
      component: () => import('@/views/rate-card/MerchantRateCard.vue'),
      meta: {
        pageTitle: 'Merchant Rate Card',
        breadcrumb: [
          {
            text: 'Merchant Rate Card',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/rate-cards/',
      },
    },
    {
      path: '/rate-card/agent',
      name: 'agent-rate-card',
      component: () => import('@/views/rate-card/AgentRateCard.vue'),
      meta: {
        pageTitle: 'Agent Rate Card',
        breadcrumb: [
          {
            text: 'Agent Rate Card',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/rate-cards/',
      },
    },
    {
      path: '/rate-card/rider',
      name: 'rider-rate-card',
      component: () => import('@/views/rate-card/RiderRateCard.vue'),
      meta: {
        pageTitle: 'Rider Rate Card',
        breadcrumb: [
          {
            text: 'Rider Rate Card',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/rate-cards/',
      },
    },
    {
      path: '/rate-card/walking-customer',
      name: 'walking-customer-rate-card',
      component: () => import('@/views/rate-card/WalkingCustomerRateCard.vue'),
      meta: {
        pageTitle: 'Walking Customer Rate Card',
        breadcrumb: [
          {
            text: 'Walking Customer Rate Card',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/rate-cards/#1-toc-title',
      },
    },
    {
      path: '/operation-settings/zone',
      name: 'zone',
      component: () => import('@/views/demarcation/ZoneManage.vue'),
      meta: {
        pageTitle: 'Zone',
        breadcrumb: [
          {
            text: 'Zone',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/operation-settings/branch',
      name: 'branch',
      component: () => import('@/views/demarcation/BranchManage.vue'),
      meta: {
        pageTitle: 'Branch',
        breadcrumb: [
          {
            text: 'Branch',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/operation-settings/agency',
      name: 'agency',
      component: () => import('@/views/demarcation/AgencyManage.vue'),
      meta: {
        pageTitle: 'Agency',
        breadcrumb: [
          {
            text: 'Agency',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/operation-settings/reasons',
      name: 'reasons',
      component: () => import('@/views/Reasons.vue'),
      meta: {
        pageTitle: 'Reasons',
        breadcrumb: [
          {
            text: 'Reasons',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
        noAuth: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/forgot-password/ForgotPassword.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
        noAuth: true,
      },
    },
    {
      path: '/reset-password/:email/:token',
      name: 'reset-password',
      component: () => import('@/views/forgot-password/ResetPassword.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
        noAuth: true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/staff-manage/staff-users',
      name: 'staff-users',
      component: () => import('@/views/staff/StaffView.vue'),
      meta: {
        pageTitle: 'Staff Management',
        breadcrumb: [
          {
            text: 'View All Staff Users',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/user-management-staff/#0-toc-title',
      },
    },
    {
      path: '/kpi/rider-assignment',
      name: 'rider-assignment',
      component: () => import('@/views/kpi/RiderAssignmentView.vue'),
      meta: {
        pageTitle: 'Rider Assignment',
        breadcrumb: [
          {
            text: 'Rider Assignment',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/user-management-staff/#0-toc-title',
      },
    },
    {
      path: '/quickbook',
      name: 'quickbook',
      component: () => import('@/views/quickBook/quickbook.vue'),
      meta: {
        pageTitle: 'QuickBooks',
        breadcrumb: [
          {
            text: 'QuickBook Integration',
            active: true,
          },
        ],
      },
    },
    {
      path: '/waybillrequest',
      name: 'waybillrequest',
      component: () => import('@/views/waybill-request/WaybillRequest.vue'),
      meta: {
        pageTitle: 'Waybill Request',
        breadcrumb: [
          {
            text: 'Waybill Request',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs-category/staff-portal/',
      },
    },
    {
      path: '/notices',
      name: 'notices',
      component: () => import('@/views/notices/Notices.vue'),
      meta: {
        pageTitle: 'Notices',
        breadcrumb: [
          {
            text: 'Notices',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs-category/staff-portal/',
      },
    },
    {
      path: '/roles',
      name: 'roles',
      component: () => import('@/views/roles/Roles.vue'),
      meta: {
        pageTitle: 'Roles',
        breadcrumb: [
          {
            text: 'Roles',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/user-management-staff/#1-toc-title',
      },
    },
    {
      path: '/roles/add',
      name: 'role-add',
      component: () => import('@/components/roles/RoleManagement.vue'),
      meta: {
        pageTitle: 'Roles',
        breadcrumb: [
          {
            text: 'Add',
            active: true,
          },
        ],
      },
    },
    {
      path: '/roles/edit/:roleId',
      name: 'role-edit',
      component: () => import('@/components/roles/RoleManagement.vue'),
      meta: {
        pageTitle: 'Roles',
        breadcrumb: [
          {
            text: 'Edit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/package-settings/my-subscription',
      name: 'my-subscription',
      component: () => import('@/views/Subscriptions.vue'),
      meta: {
        pageTitle: 'My Subscription',
        breadcrumb: [
          {
            text: 'My Subscription',
            active: true,
          },
        ],
      },
    },
    {
      path: '/package-settings/find-packages/:activePackageId',
      name: 'find-packages',
      component: () => import('@/components/SubscriptionPlan/Packages.vue'),
      meta: {
        pageTitle: 'Subscription Plans',
        breadcrumb: [
          {
            text: 'Subscription Plans',
            active: true,
          },
        ],
      },
    },
    {
      path: '/package-settings/subscription',
      name: 'subscription',
      component: () => import('@/views/adminportal/Subscription.vue'),
      meta: {
        pageTitle: 'My Subscription',
        breadcrumb: [
          {
            text: 'My Subscription',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/package-settings/subscription-billing',
      name: 'billing',
      component: () => import('@/views/adminportal/Billing.vue'),
      meta: {
        pageTitle: 'My Billing',
        breadcrumb: [
          {
            text: 'My Billing',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/package-settings/packages',
      name: 'package',
      component: () => import('@/views/adminportal/Package.vue'),
      meta: {
        pageTitle: 'My Packages',
        breadcrumb: [
          {
            text: 'My Packages',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/demarcation/',
      },
    },
    {
      path: '/package-settings/subscribe/:id',
      name: 'subscribe',
      component: () => import('@/components/SubscriptionPlan/Pay.vue'),
      meta: {
        pageTitle: 'Payment Options',
        breadcrumb: [
          {
            text: 'Pay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-invoice/:id',
      name: 'view-invoice',
      component: () => import('@/components/subsInvoive/Invoice.vue'),
      meta: {
        pageTitle: '',
      },
    },
    {
      path: '/view-package/:id',
      name: 'view-package',
      component: () => import('@/views/packages/ViewPackage.vue'),
      meta: {
        pageTitle: 'View Package',
        breadcrumb: [
          {
            text: 'View Package',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: () => import('@/views/tickets/Tickets.vue'),
      meta: {
        pageTitle: 'Tickets',
        breadcrumb: [
          {
            text: 'Tickets',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/support-feedback/#0-toc-title',
      },
    },
    {
      path: '/tickets-dashboard',
      name: 'tickets-dashboard',
      component: () => import('@/views/tickets/TicketDashboard.vue'),
      meta: {
        pageTitle: 'Tickets',
        breadcrumb: [
          {
            text: 'Tickets',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/support-feedback/#0-toc-title',
      },
    },
    {
      path: '/tickets/:id',
      name: 'ticket-details',
      component: () => import('@/views/tickets/TicketDetails.vue'),
      meta: {
        pageTitle: 'Tickets',
        breadcrumb: [
          {
            text: 'Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pickup-requests',
      name: 'pickup-requests',
      component: () => import('@/views/pickup-requests/PickupRequests.vue'),
      meta: {
        pageTitle: 'Pickup Requests',
        breadcrumb: [
          {
            text: 'Pickup Requests',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/support-feedback/#0-toc-title',
      },
    },
    {
      path: '/pickup-requests/:id',
      name: 'pickup-request-details',
      component: () => import('@/views/pickup-requests/PickupRequestDetails.vue'),
      meta: {
        pageTitle: 'Pickup Requests',
        breadcrumb: [
          {
            text: 'Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('@/views/feedback/Feedback.vue'),
      meta: {
        pageTitle: 'Feedback',
        breadcrumb: [
          {
            text: 'All',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/support-feedback/#1-toc-title',
      },
    },
    {
      path: '/reports/all-feedbacks',
      name: 'all-feedbacks',
      component: () => import('@/views/feedback/AllFeedback.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Merchants & Sales',
            to: {
              name: 'reports',
              query: { category: 'merchants-sales' },
            },
          },
          {
            text: 'Customer Feedback Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/aging-report',
      name: 'aging-report',
      component: () => import('@/views/reports/OrderCount/AgingReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Merchants & Sales',
            to: {
              name: 'reports',
              query: { category: 'merchants-sales' },
            },
          },
          {
            text: 'Merchant Aging Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/aging-report/average',
      name: 'aging-merchant',
      component: () => import('@/views/reports/OrderCount/AgingMerchant.vue'),
      meta: {
        pageTitle: 'Merchant Order Average',
        breadcrumb: [
          {
            text: 'Client Aging Report',
            to: { name: 'aging-report' },
          },
          {
            text: 'Merchant Order Average',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reports/all-order-downloads/:key',
      name: 'all-order-downloads',
      component: () => import('@/views/reports/Downloads/ReportDownloadsTable.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Downloads',
            to: {
              name: 'reports',
              query: { category: 'downloads' },
            },
          },
          {
            text: 'All Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/merchant-invoice-downloads/:key',
      name: 'merchant-invoice-downloads',
      component: () => import('@/views/reports/Downloads/ReportDownloadsTable.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Downloads',
            to: {
              name: 'reports',
              query: { category: 'downloads' },
            },
          },
          {
            text: 'Merchant Invoices',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/assign-order-downloads',
      name: 'assign-order-downloads',
      component: () => import('@/views/reports/Downloads/AssignedOrderQueuedDownloads.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Downloads',
            to: {
              name: 'reports',
              query: { category: 'downloads' },
            },
          },
          {
            text: 'Assigned Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/rider-performance-report',
      name: 'rider-performance-report',
      component: () => import('@/views/reports/StaffProductivity/RiderPerformanceReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Staff Productivity',
            to: {
              name: 'reports',
              query: { category: 'staff-productivity' },
            },
          },
          {
            text: 'Rider Performance Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/branch-performance-report',
      name: 'branch-performance-report',
      component: () => import('@/views/reports/StaffProductivity/BranchPerformanceReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Staff Productivity',
            to: {
              name: 'reports',
              query: { category: 'staff-productivity' },
            },
          },
          {
            text: 'Branch Performance Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/branch-dispatched-report',
      name: 'branch-dispatched-report',
      component: () => import('@/views/reports/StaffProductivity/BranchWiseDispatchedReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Staff Productivity',
            to: {
              name: 'reports',
              query: { category: 'staff-productivity' },
            },
          },
          {
            text: 'Branch Wise Dispatched Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/merchant-dispatched-report',
      name: 'merchant-dispatched-report',
      component: () => import('@/views/reports/StaffProductivity/MerchantWiseDispatchedReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'Staff Productivity',
            to: {
              name: 'reports',
              query: { category: 'staff-productivity' },
            },
          },
          {
            text: 'Merchant Wise Dispatched Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/merchant-wise-ticket-report',
      name: 'merchant-wise-ticket-report',
      component: () => import('@/views/reports/CRM/MerchantWiseTicketReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'CRM',
            to: {
              name: 'reports',
              query: { category: 'crm' },
            },
          },
          {
            text: 'Merchant Wise Ticket Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/merchant-wise-ticket-report',
      name: 'merchant-wise-ticket-report',
      component: () => import('@/views/reports/CRM/MerchantWiseTicketReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'CRM',
            to: {
              name: 'reports',
              query: { category: 'crm' },
            },
          },
          {
            text: 'Merchant Wise Ticket Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/warehouse-wise-ticket-report',
      name: 'warehouse-wise-ticket-report',
      component: () => import('@/views/reports/CRM/WarehouseWiseTicketReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'CRM',
            to: {
              name: 'reports',
              query: { category: 'crm' },
            },
          },
          {
            text: 'Warehouse Wise Ticket Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/status-wise-ticket-report',
      name: 'status-wise-ticket-report',
      component: () => import('@/views/reports/CRM/StatusWiseTicketReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'CRM',
            to: {
              name: 'reports',
              query: { category: 'crm' },
            },
          },
          {
            text: 'Status Wise Ticket Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/role-wise-ticket-report',
      name: 'role-wise-ticket-report',
      component: () => import('@/views/reports/CRM/RoleWiseTicketReport.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            to: { name: 'reports' },
          },
          {
            text: 'CRM',
            to: {
              name: 'reports',
              query: { category: 'crm' },
            },
          },
          {
            text: 'Role Wise Ticket Report',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/reports/',
      },
    },
    {
      path: '/reports/download/:key',
      name: 'selected-report-download',
      component: () => import('@/views/reports/Downloads/SelectedReportDownload.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Downloads',
            to: { name: 'report-downloads' },
          },
          {
            text: 'All Orders',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/operations-2/#2-toc-title',
      },
    },
    {
      path: '/rate-us/:code',
      name: 'customer-feedback',
      component: () => import('@/views/feedback/CustomerFeedback.vue'),
      meta: {
        layout: 'full',
        noAuth: true,
      },
    },
    {
      path: '/checkout/:id/:name',
      name: 'payment-checkout',
      component: () => import('@/views/payments/CustomerCheckout.vue'),
      meta: {
        layout: 'full',
        noAuth: true,
      },
    },
    {
      path: '/return',
      name: 'payment-success',
      component: () => import('@/views/payments/PaymentSuccess.vue'),
      meta: {
        layout: 'full',
        noAuth: true,
      },
    },
    // Resource Page Routes
    {
      path: '/resources',
      name: 'resources',
      component: () => import('@/views/resource/Resource.vue'),
      meta: {
        pageTitle: 'Resources',
        breadcrumb: [
          {
            text: 'Resources',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },
    {
      path: '/resources/view-mobile-app-resources',
      name: 'mobile-app',
      component: () => import('@/views/resource/MobileApp.vue'),
      meta: {
        pageTitle: 'Resources',
        breadcrumb: [
          {
            text: 'Resources',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/resources/',
      },
    },

    {
      path: '/resources/view-merchant-resource',
      name: 'merchant',
      component: () => import('@/views/resource/MerchantResources.vue'),
      meta: {
        pageTitle: 'Resources',
        breadcrumb: [
          {
            text: 'Resources',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },

    {
      path: '/resources/view-customer-resources',
      name: 'customer',
      component: () => import('@/views/resource/CustomerResources.vue'),
      meta: {
        pageTitle: 'Resources',
        breadcrumb: [
          {
            text: 'Resources',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },

    {
      path: '/resources/view-other-resources',
      name: 'other',
      component: () => import('@/views/resource/OtherResources.vue'),
      meta: {
        pageTitle: 'Resources',
        breadcrumb: [
          {
            text: 'Resources',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },
    {
      path: '/approvals/profile-update',
      name: 'profile-update-approval-request-list',
      component: () => import('@/views/approvals/ProfileUpdateApproval.vue'),
      meta: {
        pageTitle: 'Approvals',
        breadcrumb: [
          {
            text: 'Profile Update',
            active: true,
          },
        ],
        help: 'https://curfox.com/docs/settings-2/',
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
